var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll2 = function SvgScroll2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_2_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 158 335",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient",
    cx: 153.1975,
    cy: 329.9329,
    r: 318.6401,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-2",
    cx: 124.6667,
    cy: 244.0224,
    r: 199.9265,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_2_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-3",
    cx: 129.4505,
    cy: 268.989,
    r: 258.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-4",
    cx: 96.4835,
    cy: 291.4066,
    r: 149.384,
    xlinkHref: "#scroll_2_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-5",
    cx: 42.1306,
    cy: 309.056,
    r: 239.6997,
    xlinkHref: "#scroll_2_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-6",
    cx: 111.2527,
    cy: 300.6062,
    r: 370.2564,
    xlinkHref: "#scroll_2_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-7",
    cx: 141.9724,
    cy: 258,
    r: 221.1684,
    gradientTransform: "translate(-271.4087 397.1751) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f77a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f18c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-8",
    cx: 158.5869,
    cy: 311.2147,
    r: 122.5169,
    gradientTransform: "translate(-271.4087 397.1751) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-9",
    cx: 347.3885,
    cy: 267.9889,
    r: 129.6362,
    gradientTransform: "translate(-271.4087 397.1751) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-10",
    cx: 28.8088,
    cy: 191.0084,
    r: 149.4797,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4754,
    stopColor: "#a0f596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    stopColor: "#5ef9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-11",
    cx: 219.7858,
    cy: 178.302,
    r: 173.0918,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4345,
    stopColor: "#50dac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    stopColor: "#92e99c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abee8d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-12",
    cx: 0.7178,
    cy: 215.9667,
    r: 158.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8e0ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0649,
    stopColor: "#c1e1ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#80eca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67f0a5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-13",
    cx: 11.2788,
    cy: 42.9654,
    r: 70.5853,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#6af66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-14",
    cx: 207.5506,
    cy: 64.4979,
    r: 132.9737,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-15",
    cx: 228.194,
    cy: 160.2785,
    r: 174.5168,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad7b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43ebab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-16",
    cx: 197.4617,
    cy: 205.9275,
    r: 143.0893,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2adaa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-17",
    cx: 244.329,
    cy: 276.4716,
    r: 276.2517,
    gradientTransform: "translate(-9.1605 1.8643) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#39c2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7934,
    stopColor: "#7aec95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93fd89"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_2_svg__radial-gradient-18",
    cx: 114.6051,
    cy: 124.9231,
    r: 79.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34e09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#6cf27c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85fa6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_2_svg__top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_2_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9531,123.5744Q16.9766,147.7872,28,172q11,47.5,22,95,14,34,28,68l63-121q6.5-38.5,13-77-2.5-11.5-5-23L116,52,73,7,4,102Q4.9765,112.7873,5.9531,123.5744Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_2_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,124l52,56-29-6Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,172q11,47.5,22,95l22-15q-7-36-14-72Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,235l22,17-8,14-25-6Q94.5,247.5,100,235Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,214l-41,21,22,17Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,252l17,8,24,7L78,335q-14-34-28-68Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-6)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_2_svg__shapes_copy_5",
    "data-name": "shapes copy 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,101l6,23,52,56,17-5q5-20.5,10-41L6,102Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,101l74.1539-2.6969L76,101q2.5,16,5,32v4Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,101l74.1539-2.6969L78,93l3.2559-21.9469L72,0Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5638,252.386q-6.859-36.2492-13.7183-72.4984L72,172q.5,1,1,2-.5,38-1,76Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,260q5.5-12.5,11-25,.5-2,1-4L83,142l-2-5-9,35-.4362,80.386L74,255l13,6Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5638,252.386,78,335q5.5-37.5,11-75Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,71l21.2112-1.6415q1.941-1.4967,3.8985-3.1307a127.8005,127.8005,0,0,0,16.4611-16.554L72,0Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,71l3,4,71,44h3q-8.2283-17.1723-17.28-34.9081-9.049-17.7063-18.1492-34.4181Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,71l77,48v20.4615L156,140,89,108q-4-17-8-34Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,107l68,32.4615Q149.5,176.7308,141,214l-3-1L84,144l-3-7q.5-4,1-8,3.5-10.5,7-21Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,137q9.5,49,19,98l41-21Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,107l-9,30q-3.423-19.3485-6.8461-38.6969Q77.5771,84.6516,81,71Z",
    style: {
      fill: "url(#scroll_2_svg__radial-gradient-18)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_2_svg__highlights_copy_2",
    "data-name": "highlights copy 2",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,0,89,17,73,2l3,30Q74,17,72,2,53.2337,27.1741,53,27,52.7588,26.8236,72,0Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,75,73,97l-40,3,40-1,6,29q-2-15-4-30Q77.5,86.5,80,75Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,126l28,13q-4,18-8,36,3.5-17.5,7-35Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_2.5bec2669af487c6667b99af8970af601.svg";